import React from 'react';
import { StyleSheet, View } from 'react-native';

import Image from '@components/Image';
import { PrimaryHeadline } from '@components/Typography';

export type CreatePlanScreenHeaderProps = {
  /** Image shown above the heading. */
  source: React.ComponentProps<typeof Image>['source'];
  /** Visible screen heading. */
  text: string;
} & React.ComponentProps<typeof View>;

export default function CreatePlanScreenHeader({
  source,
  text,
  style,
  ...props
}: CreatePlanScreenHeaderProps) {
  return (
    <View style={[styles.container, style]} {...props}>
      <Image source={source} disablePlaceholder style={styles.headerImage} contentFit="contain" />
      <PrimaryHeadline style={styles.headerText}>{text}</PrimaryHeadline>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
  },
  headerImage: {
    height: 200,
    width: '100%',
  },
  headerText: {
    textAlign: 'center',
  },
});
